export default {
  image: 'k2.jpg',
  productData: {
    name: 'Konservierungsmittelfreies System K2',
    shorthand: "K2",
    advantages: [
      "Allergiker-geeignet",
      "Natürlicher Schimmelschutz",
      "Sehr glatte Oberflächen",
      "Streiflichtunempfindlich"
    ],
    technical: [
      "Schimmelschutz",
      "Glatte Flächen",
      "Glanzgrad stumpfmatt",
      "Erhöhte optische Ansprüche",
      "Nature Plus",
      "TÜV"
    ],
    systemStructure: [
      {
        type: 'subsurface',
        layer: 1,
        products: [0],
        selectedProduct: 0,
        changedProduct: false
      },
      {
        type: 'joints',
        layer: 2,
        products: [1],
        selectedProduct: 1,
        changedProduct: false
      },
      {
        type: 'surfaceFilling',
        layer: 3,
        products: [51, 52],
        selectedProduct: 51,
        changedProduct: false
      },
      {
        type: 'firstCoat',
        layer: 4,
        products: [53],
        selectedProduct: 53,
        changedProduct: false
      },
      {
        type: 'intermediateCoat',
        layer: 5,
        products: [55],
        selectedProduct: 55,
        changedProduct: false
      },
      {
        type: 'glue',
        layer: 6,
        products: [23],
        selectedProduct: 23,
        changedProduct: false
      },
      {
        type: 'wallCovering',
        layer: 7,
        products: [24, 25, 26],
        selectedProduct: 24,
        changedProduct: false
      },
      {
        type: 'finalCoatLayer1',
        layer: 8,
        products: [27, 22],
        selectedProduct: 27,
        changedProduct: false
      },
      {
        type: 'finalCoatLayer2',
        layer: 8,
        products: [27, 22],
        selectedProduct: 27,
        changedProduct: false
      }
    ],
    construction: {
      composition: [
        {
          title: { de: 'Systemgruppen' },
          output: 'Ökologisches System',
          type: 'systemGroup',
          value: 'systemgroup-2'
        },
        {
          title: { de: 'Räume' },
          output: 'Wohnräume',
          type: 'room',
          value: 'room-1'
        },
        {
          title: { de: 'Räume' },
          output: 'Flur',
          type: 'room',
          value: 'room-4'
        },
        {
          title: { de: 'Räume' },
          output: 'Keller',
          type: 'room',
          value: 'room-5'
        },
        {
          title: { de: 'Umwelt- und Gesundheitsaspekte' },
          output: 'Schadstoffgeprüft',
          type: 'environmentHealth',
          value: 'environmenthealth-1'
        },
        {
          title: { de: 'Umwelt- und Gesundheitsaspekte' },
          output: 'TÜV',
          type: 'environmentHealth', 
          value: 'environmenthealth-2'
        },
        {
          title: { de: 'Umwelt- und Gesundheitsaspekte' },
          output: 'natureplus',
          type: 'environmentHealth', 
          value: 'environmenthealth-3'
        },
        {
          title: { de: 'Umwelt- und Gesundheitsaspekte' },
          output: 'SentinelHaus',
          type: 'environmentHealth', 
          value: 'environmenthealth-4'
        },
        {
          title: { de: 'Umwelt- und Gesundheitsaspekte' },
          output: 'Konservierungsmittelfrei (Farbe/Putz)',
          type: 'environmentHealth', 
          value: 'environmenthealth-7'
        },
        {
          title: { de: 'Umwelt- und Gesundheitsaspekte' },
          output: 'Allergiker-geeignet',
          type: 'environmentHealth', 
          value: 'environmenthealth-8'
        },
        {
          title: { de: 'Belastbarkeit' },
          output: 'Streiflichtunempfindlich',
          type: 'resilience', 
          value: 'resilience-2'
        },
        {
          title: { de: 'Belastbarkeit' },
          output: 'Risssicher',
          type: 'resilience', 
          value: 'resilience-6'
        },
        {
          title: { de: 'Design / Oberfläche' },
          output: 'Matt',
          type: 'designSurface', 
          value: 'designsurface-1'
        },
        {
          title: { de: 'Design / Oberfläche' },
          output: 'Glatt',
          type: 'designSurface', 
          value: 'designsurface-6'
        },
        {
          title: { de: 'Design / Oberfläche' },
          output: 'Erhöhte optische Ansprüche',
          type: 'designSurface', 
          value: 'designsurface-8'
        },
        {
          title: { de: 'Verarbeitung' },
          output: 'Einfach',
          type: 'processing', 
          value: 'processing-1'
        },
        {
          title: { de: 'Verarbeitung' },
          output: 'Schnell',
          type: 'processing', 
          value: 'processing-4'
        },
        {
          title: { de: 'Verarbeitungszeit' },
          output: 'Stufe 2',
          type: 'processingTime', 
          value: 'processingtime-2'
        },
        {
          title: { de: 'Preisniveau' },
          output: '€',
          type: 'priceLevel', 
          value: 'pricelevel-1'
        }
      ]
    }
  }
}
